import React from 'react';
import UploadedFileViewDelete from '../UploadedFileViewDelete';
import styles from './styles.module.scss';

const ListUploadedFilesViewDelete = ({
                                       data = [],
                                       fileTypeID,
                                       shumaId = null,
                                     }) => {
  const list = data.filter(item => item?.fileName && item?.shumaID && item?.fileTypeID === fileTypeID);

  return list.length > 0 && (
    <div className={styles.formContainer}>
      {list.map((item, ind) => (
        <UploadedFileViewDelete
          {...item}
          containerClassName={styles.item}
          key={ind}
          shumaId={shumaId}
        />
      ))}
    </div>
  );
};

export default ListUploadedFilesViewDelete;
